module.exports = __webpack_public_path__ + "media/hyper/images/payments/amazon-02fbc060f6be983c4f4ca90776448f82.png";